'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const Footer = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [currentYear, setCurrentYear] = useState('2026');

  useEffect(() => {
    setIsHydrated(true);
    setCurrentYear(new Date().getFullYear().toString());
  }, []);

  const footerLinks = [
    { name: 'Performance', href: '#performance' },
    { name: 'Achievements', href: '#achievements' },
    { name: 'Builds', href: '#builds' },
    { name: 'Contact', href: '#contact' },
  ];

  const socialLinks = [
    { name: 'Discord', icon: 'ChatBubbleLeftRightIcon', href: '#' },
    { name: 'Twitter', icon: 'AtSymbolIcon', href: '#' },
    { name: 'Twitch', icon: 'VideoCameraIcon', href: '#' },
  ];

  return (
    <footer className="bg-deep-void border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20 2L4 12V28L20 38L36 28V12L20 2Z"
                  stroke="url(#frostGradient)"
                  strokeWidth="2"
                  fill="rgba(0,204,255,0.1)"
                />
                <path d="M20 10L12 15V25L20 30L28 25V15L20 10Z" fill="url(#bloodGradient)" />
                <defs>
                  <linearGradient id="frostGradient" x1="4" y1="2" x2="36" y2="38">
                    <stop offset="0%" stopColor="#00ccff" />
                    <stop offset="100%" stopColor="#0066ff" />
                  </linearGradient>
                  <linearGradient id="bloodGradient" x1="12" y1="10" x2="28" y2="30">
                    <stop offset="0%" stopColor="#cc0000" />
                    <stop offset="100%" stopColor="#660000" />
                  </linearGradient>
                </defs>
              </svg>
              <div>
                <h3 className="font-orbitron text-xl font-bold">
                  <span className="text-blood-red">Only</span>
                  <span className="text-metallic-silver">Fabbz</span>
                </h3>
                <p className="text-xs font-inter text-frost-blue tracking-widest">DEATH KNIGHT</p>
              </div>
            </div>
            <p className="font-inter text-sm text-muted-foreground">
              Elite Death Knight showcasing mastery in World of Warcraft's most challenging endgame content.
            </p>
          </div>
        </div>
          
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="font-inter text-sm text-muted-foreground">
              {isHydrated ? `© ${currentYear}` : '© 2026'} OnlyFabbz. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="font-inter text-sm text-muted-foreground hover:text-frost-blue transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="font-inter text-sm text-muted-foreground hover:text-frost-blue transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;